import config from 'configDir/index';
import { get } from './http';

const baseUrl = '/download';

// 获取对象的任务列表
const queryTaskListByTargetIdService = get(
  `${baseUrl}/getTaskListByTargetId`,
  config.commonServiceUrl,
);
// 获取指定任务详情
const getTaskByUniqueIdService = get(`${baseUrl}/getTaskByUniqueId`, config.commonServiceUrl);
// 获取多个任务
const getTaskByUniqueIdsService = get(`${baseUrl}/getTaskByUniqueIds`, config.commonServiceUrl);

export { queryTaskListByTargetIdService, getTaskByUniqueIdService, getTaskByUniqueIdsService };
